import { auth } from '@chattee.ai/auth'
import backend from '../backend/backend'
import { setCsrfToken } from '../backend/httpAPI'
import { AuthActions } from './authReducer'
import { DataActions } from './dataReducer'

const applyMe = (dispatch, me) => {
  setCsrfToken(me.csrfToken)
  dispatch({ type: AuthActions.SET_SESSION, me })
}

/** On page load: is there a live staff session (platform session + gate cookie)? */
export const restoreSession = () => async (dispatch) => {
  try {
    applyMe(dispatch, await backend.getMe())
  } catch {
    dispatch({ type: AuthActions.CLEAR })
  }
}

/** Platform sign-in, then the staff gate. Returns the next step: 'verify' | 'enrol' | 'done'. */
export const signIn = (email, password, turnstileToken) => async (dispatch) => {
  await auth.signIn({ email, password, ...(turnstileToken ? { turnstileToken } : {}) })
  try {
    const gate = await backend.openGate()
    setCsrfToken(gate.csrfToken)
    applyMe(dispatch, await backend.getMe())
    return gate.step
  } catch (err) {
    await auth.signOut().catch(() => {})
    throw err
  }
}

export const refreshMe = () => async (dispatch) => applyMe(dispatch, await backend.getMe())

export const signOut = (expired = false) => async (dispatch) => {
  await backend.logout().catch(() => {})
  await auth.signOut().catch(() => {})
  setCsrfToken('')
  dispatch({ type: DataActions.RESET })
  dispatch({ type: AuthActions.CLEAR, expired })
}

/** Called when the server says the session is gone (idle, absolute expiry, signed out elsewhere). */
export const sessionExpired = () => async (dispatch) => {
  await auth.signOut().catch(() => {})
  setCsrfToken('')
  dispatch({ type: DataActions.RESET })
  dispatch({ type: AuthActions.CLEAR, expired: true })
}
